import React, { useState, useEffect } from 'react';
import Button from '../../../../../ui/canon/Button';
import { SendIcon } from 'lucide-react';

const TimelineWidget = ({ onAnswer, disabled, initialValue = null }) => {
  const getInitialDates = () => {
    if (initialValue && typeof initialValue === 'object') {
      return {
        startDate: initialValue.startDate || '',
        endDate: initialValue.endDate || ''
      };
    }
    return { startDate: '', endDate: '' };
  };

  const initial = getInitialDates();
  const [startDate, setStartDate] = useState(initial.startDate);
  const [endDate, setEndDate] = useState(initial.endDate);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const dates = getInitialDates();
    setStartDate(dates.startDate);
    setEndDate(dates.endDate);
    setIsSubmitting(false);
  }, [initialValue]);

  const handleSubmit = () => {
    if (startDate && endDate && !isSubmitting) {
      setIsSubmitting(true);
      onAnswer({ value: { startDate, endDate }, formatted: `${startDate} to ${endDate}` });
    }
  };

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-succession-text-secondary mb-1">Start Date</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            disabled={disabled || isSubmitting}
            className="w-full px-3 py-2 border border-succession-border rounded-md bg-succession-bg-primary text-succession-text-primary"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-succession-text-secondary mb-1">End Date</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            disabled={disabled || isSubmitting}
            className="w-full px-3 py-2 border border-succession-border rounded-md bg-succession-bg-primary text-succession-text-primary"
          />
        </div>
      </div>
      <Button
        onClick={handleSubmit}
        disabled={!startDate || !endDate || disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        Submit Timeline
      </Button>
    </div>
  );
};

export default TimelineWidget;
